import { render, staticRenderFns } from "./BaseInfoPanel.vue?vue&type=template&id=4d593eec&scoped=true"
import script from "./BaseInfoPanel.vue?vue&type=script&lang=js"
export * from "./BaseInfoPanel.vue?vue&type=script&lang=js"
import style0 from "./BaseInfoPanel.vue?vue&type=style&index=0&id=4d593eec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d593eec",
  null
  
)

export default component.exports